<template>
  <div class="detail-content">
    <heads :titleList="list" :active="active" @getActive="getActive"></heads>
    <div v-if="active==='详情'" class="detial-info">
      <el-row :gutter="30">
        <el-col :span="8">
          <div class="imgtext-box">
            <div class="image">
              <img :src="articleInfo.cover" alt />
            </div>
            <div class="title">{{articleInfo.articletitle}}</div>
            <div class="link">
              <p>原文链接:</p>
              <p>{{articleInfo.sourceurl}}</p>
            </div>
            <div class="type">
              <p>分类</p>
              <el-tag v-for="(item,index) in articleInfo.articletype" :key="index">{{item}}</el-tag>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="message-box">
            <div class="message-head">
              <span>留言</span>
              <el-radio-group v-model="tabPosition" size="small">
                <el-radio-button label="普通">普通</el-radio-button>
                <el-radio-button label="精选">精选</el-radio-button>
              </el-radio-group>
            </div>
            <div class="message-abroad">暂未开通留言功能，敬请期待！</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="active==='预览'" class="preview-info">
      <el-scrollbar style="height: 100%" ref="myScrollbar" class="page-component__scroll">
        <div v-html="articleInfo.articlecontent" class="preview-box"></div>
      </el-scrollbar>
      <el-backtop target=".page-component__scroll .el-scrollbar__wrap" :bottom="100">
        <i class="el-icon-arrow-up"></i>
      </el-backtop>
    </div>
  </div>
</template>
<script>
import api from "@/api/news/publish.js";
import heads from "@/components/header.vue";
export default {
  components: { heads },
  data() {
    return {
      list: [
        { name: "详情", showSave: false },
        { name: "预览", showSave: false }
      ],
      active: "详情",
      tabPosition: "普通",
      articleInfo: {},
      content: "<p>预览详情</p>",
      typeList: []
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  mounted() {
    this.getTypeList();
    this.getData();
  },
  methods: {
    async getTypeList() {
      let data = {
        page: 1,
        rows: 100,
        communityId: this.userInfo.communityId
      };
      let res = await this.$http.get(api.typeList, { params: data });
      if (res && res.isSucceed) {
        this.typeList = res.rows;
        this.getData();
      }
    },

    async getData() {
      let res = await this.$http.get(`${api.articleInfo}?id=${this.id}`);
      if (res && res.isSucceed) {
        this.articleInfo = res.rows && res.rows.length > 0 ? res.rows[0] : {};
        let typeName = [];
        let articleType = this.articleInfo.articletype
          ? this.articleInfo.articletype.split(",")
          : [];
        for (let item of this.typeList) {
          for (let type of articleType) {
            if (item.id == type) {
              typeName.push(item.name);
            }
          }
        }
        this.articleInfo.articletype = JSON.parse(JSON.stringify(typeName));
      }
    },
    getActive(name) {
      this.active = name;
    }
  }
};
</script>
<style lang='less' scoped>
@import url("./detail.less");
</style>